<template>
  <div class="date">
    <label>{{ $t('root.filters.expiration_date') }}</label>

    <div v-on:keydown.enter.prevent="filter">
      <datepicker v-model="min" input-class="form-control expiration-input" :full-month-name="true" :monday-first="true" :placeholder="$t('root.filters.expiration_date_from')" />
      <datepicker v-model="max" input-class="form-control expiration-input" :full-month-name="true" :monday-first="true" :placeholder="$t('root.filters.expiration_date_to')" />
    </div>

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')" >{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker'

  export default {
    components: {
      datepicker: Datepicker
    },
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        min: null,
        max: null,
      }
    },
    computed: {
      minDate() {
        return new Date(this.min)
      },
      maxDate() {
        return new Date(this.max)
      },
    },
    methods: {
      filter() {
        let newQuery = Object.assign({}, this.query)

        delete newQuery['filters[expiration_date_gteq]']
        delete newQuery['filters[expiration_date_lteq]']

        if (this.minDate != 'Invalid Date')
          newQuery = Object.assign({}, newQuery, { page: 1, parent_id: this.folder.id, 'filters[expiration_date_gteq]': this.minDate.toISOString() })

        if (this.maxDate != 'Invalid Date')
          newQuery = Object.assign({}, newQuery, { page: 1, parent_id: this.folder.id, 'filters[expiration_date_lteq]': this.maxDate.toISOString() })

        this.$router.push({ query: newQuery })
      },
    }
  }
</script>
<style lang="sass" scoped>
  .date
    width: 325px
    padding: 10px
  .float-right
    margin-top: 15px
  .vdp-datepicker
    margin-bottom: 10px
</style>
